export const BOTTOM_BAR_DIALOG_ACTION_EVENT = 'layout-bottom-bar-dialog-action';

export type BottomBarDialogAction =
  | 'openClientDialog'
  | 'openVisitDialog'
  | 'openStockItemDialog'
  | 'openServiceDialog';

export type BottomBarDialogActionEventDetail = {
  action: BottomBarDialogAction;
};

const emitBottomBarDialogAction = (action: BottomBarDialogAction) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<BottomBarDialogActionEventDetail>(BOTTOM_BAR_DIALOG_ACTION_EVENT, {
      detail: { action },
    }),
  );
};

export const openClientFormDialog = () => emitBottomBarDialogAction('openClientDialog');
export const openVisitFormDialog = () => emitBottomBarDialogAction('openVisitDialog');
export const openStockItemFormDialog = () => emitBottomBarDialogAction('openStockItemDialog');
export const openServiceFormDialog = () => emitBottomBarDialogAction('openServiceDialog');
